// import React from "react";
// import "./Journey.css";  // Ensure you are importing the CSS file

// export default function Journey() {
//   const steps = [
//     { year: "1962", desc: "Joint venture with Clayton Dewandre Holdings Plc" },
//     { year: "1968", desc: "Established Diecasting facility" },
//     { year: "1998", desc: "Deming Prize (Brakes Division) by JUSE" },
//     { year: "2002", desc: "Japanese Quality Medal (Brakes Division) by JUSE" },
//     { year: "2005", desc: "Established separate facility for brakes" },
//     { year: "2007", desc: "Spun-off Brakes division as Wabco-TVS" },
//     { year: "2009", desc: "Established plant at Mahindra World City (MWC)" },
//     { year: "2010", desc: "Established Oragadam plant - Phase 1" },
//     { year: "2011", desc: "Platinum Certificate of Merit - The Economic Times Manufacturing Excellence Awards" },
//     { year: "2018", desc: "Established Oragadam plant - Phase 2" },
//     { year: "2019", desc: "Established Overseas plant in USA" },
//     { year: "2024", desc: "Introduced SCL's first 4400 T machine in US Plant" },
//     { year: "2025", desc: "Established Smart Mega die-casting facility at Thervoy Kandigai" }
//   ];

//   // X gap between steps
//   const gap = 160;

//   return (
//     <div className="timeline-container">
//       <h1 style={{ textAlign: "center", margin: "50px 0 30px 0" }}>
//         OUR JOURNEY
//       </h1>

//       <div className="timeline-wrap" id="journey">
//         <svg
//           viewBox={`0 0 ${steps.length * gap + 400} 420`} // 🔹 added extra right space
//           className="timeline-svg"
//           preserveAspectRatio="xMidYMid meet"
//           aria-hidden="true"
//         >
//           {/* Dark connector path */}
//           <path
//             d={`M120 260
//               ${steps
//                 .slice(1)
//                 .map((_, i) => {
//                   const x1 = 120 + i * gap;
//                   const y1 = i % 2 === 0 ? 260 : 120;
//                   const x2 = 120 + (i + 1) * gap;
//                   const y2 = (i + 1) % 2 === 0 ? 260 : 120;
//                   return `C${x1 + 100} ${y1}, ${x1 + 100} ${y2}, ${x2} ${y2}`;
//                 })
//                 .join(" ")}
//             `}
//             fill="none"
//             stroke="#0A1F44"
//             strokeWidth="30"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />

//           {/* White highlight line */}
//           <path
//             d={`M140 260
//               ${steps
//                 .slice(1)
//                 .map((_, i) => {
//                   const x1 = 140 + i * gap;
//                   const y1 = i % 2 === 0 ? 260 : 140;
//                   const x2 = 140 + (i + 1) * gap;
//                   const y2 = (i + 1) % 2 === 0 ? 260 : 140;
//                   return `C${x1 + 100} ${y1}, ${x1 + 100} ${y2}, ${x2} ${y2}`;
//                 })
//                 .join(" ")}
//             `}
//             fill="none"
//             stroke="rgba(255,255,255,0.7)"
//             strokeWidth="6"
//             strokeLinecap="round"
//           />

//           {/* Dynamic nodes */}
//           {steps.map((s, i) => {
//             const x = 120 + i * gap;
//             const y = i % 2 === 0 ? 260 : 120;
//             return (
//               <g key={i} className="node" transform={`translate(${x},${y})`}>
//                 <circle r="60" className="node-face" />
//                 <circle r="58" className="node-inner" />
//                 <text className="node-step" x="0" y="10" textAnchor="middle">
//                   {s.year}
//                 </text>
//               </g>
//             );
//           })}
//         </svg>

//         <div className="captions">
//           {steps.map((s, i) => {
//             const x = 120 + i * gap;
//             const y = i % 2 === 0 ? 260 : 120;
//             const captionTop = i % 2 === 0 ? y + 40 : y - 150;

//             return (
//               <div
//                 key={i}
//                 className="caption"
//                 style={{
//                   left: `${x}px`,
//                   top: `${captionTop}px`,
//                 }}
//               >
//                 <p>{s.desc}</p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }


// import React from "react";
// import "./Journey.css";

// const Journey = () => {
//   const milestones = [
//     { year: "1962", text: "Joint venture with Clayton Dewandre Holdings Plc" },
//     { year: "1968", text: "Established Diecasting facility" },
//     { year: "1998", text: "Deming Prize (Brakes Division) by JUSE" },
//     { year: "1998", text: "Established plant at Hosur" },
//     { year: "2002", text: "Japanese Quality Medal (Brakes Division) by JUSE" },
//     { year: "2005", text: "Established separate facility for brakes" },
//     { year: "2007", text: "Spun-off Brakes division as Wabco-TVS" },
//     { year: "2009", text: "Established plant at Mahindra World City (MWC)" },
//     { year: "2010", text: "Established Oragadam plant – Phase 1" },
//     { year: "2011", text: "Platinum Certificate of Merit – Economic Times Manufacturing Excellence Awards" },
//     { year: "2018", text: "Established Oragadam plant – Phase 2" },
//     { year: "2019", text: "Established Overseas plant in USA" },
//     { year: "2024", text: "Introduced SCL’s first 4400 T machine in US plant" },
//     { year: "2025", text: "Established Smart Mega die-casting facility at Thervoy Kandigai" },
//   ];

//   return (
//     <div className="journey-container">
//       <h2 className="journey-title">Our Journey</h2>
//       <div className="jou-underline"></div>
//       <div className="journey-line">
//         {milestones.map((item, index) => (
//           <div key={index} className="journey-item">
//             <div className="journey-circle">{item.year}</div>
//             <div className={`journey-text ${index % 2 === 0 ? "top" : "bottom"}`}>
//               <p>{item.text}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Journey;


import React, { useState } from "react";
import { motion } from "framer-motion";
import "./Journey.css";
import journey from "../assets/journey.png";
import { FaLeaf, FaHandsHelping, FaGraduationCap, FaUsers } from "react-icons/fa";
import Footer from "./Footer";

export default function Timeline() {
  const [layout, setLayout] = useState("vertical"); 

  const milestones = [
    {
      year: "1996",
      title: "Foundation",
      description: "SST was founded to uplift rural India through sustainable development.",
      icon: <FaLeaf />,
    },
    {
      year: "2005",
      title: "Education Expansion",
      description: "Launched several education initiatives to promote literacy and skill building.",
      icon: <FaGraduationCap />,
    },
    {
      year: "2012",
      title: "Community Growth",
      description: "Partnered with local communities to establish healthcare and water programs.",
      icon: <FaHandsHelping />,
    },
    {
      year: "2023",
      title: "Empowering Lives",
      description: "SST impacted over 16 lakh lives through its multi-sectoral development programs.",
      icon: <FaUsers />,
    },
  ];

  return (
    <section id="journey">
    <div className="timeline-container">
      <h1 className="timeline-title">Our Journey</h1>
      <div className="jou-underline"></div>
      <img src={journey} alt="journey" />
      {/* <h1 className="timeline-title">SST Milestone Journey</h1>

      <div className="toggle-buttons">
        <button
          className={layout === "vertical" ? "active" : ""}
          onClick={() => setLayout("vertical")}
        >
          Vertical
        </button>
        <button
          className={layout === "horizontal" ? "active" : ""}
          onClick={() => setLayout("horizontal")}
        >
          Horizontal
        </button>
      </div>

      <div className={`timeline ${layout}`}>
        {milestones.map((item, index) => (
          <motion.div
            className="timeline-item"
            key={index}
            initial={{ opacity: 0, y: layout === "vertical" ? 50 : 0, x: layout === "horizontal" ? 50 : 0 }}
            animate={{ opacity: 1, y: 0, x: 0 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
          >
            <div className="timeline-icon">{item.icon}</div>
            <div className="timeline-content">
              <h3>{item.year}</h3>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          </motion.div>
        ))}
      </div> */}
    </div>

    <Footer />
    </section>
  );
}
